<script lang="ts" setup>
import { Error } from '@ui'
import {
  useSettingStore,
} from 'pinia-store'
import ButtonLitepicker from '@ui/base-components/widget/ButtonLitepicker.vue'
import ButtonLanguage from '@ui/base-components/widget/ButtonLanguage.vue'
import { initFlowbite } from 'flowbite'
import { onMounted } from 'vue'
import { savoyAdjustBasedColor } from '@ui/helpers/savoyAdjustBasedColor'

// import ProgressiveWebApp from '@/components/ProgressiveWebApp.vue'

const headerComponent = shallowRef({})
const footerComponent = shallowRef({})
const useSetting = useSettingStore()

try {
  headerComponent.value = await resolveComponent('LazyComponentsHeader')
  footerComponent.value = await resolveComponent('LazyComponentsFooter')
}
catch (e) {
  headerComponent.value = Error
}

definePageMeta({
  middleware: [
    'setup',
  ],
})

/**
 * NOTE:
 * only for savoy template since implemented 4 based color scheme.
 *
 * TODO:
 * delete later once the color scheme is implemented in the admin panel.
 */
const {
  primary,
  secondary,
  tertiary,
  quaternary,
} = savoyAdjustBasedColor(useSetting.cssVars, import.meta.env.VITE_APP_HOTEL_ID)
if (tertiary || quaternary) { // if not null and only set for specific hotel ID
  // set based color scheme
  useSetting.cssVars['--color-primary'] = primary
  useSetting.cssVars['--color-secondary'] = secondary
  useSetting.cssVars['--color-tertiary'] = tertiary
  useSetting.cssVars['--color-quaternary'] = quaternary
}

onMounted(() => {
  initFlowbite()
})
</script>

<template>
  <GeneratePage />
  <component
    :is="headerComponent"
  />
  <main
    :data-version="useSetting.version"
    class="main"
  >
    <slot />
    <!-- <ProgressiveWebApp /> -->
    <ButtonLitepicker />
  </main>
  <ButtonLanguage />
  <component
    :is="footerComponent"
  />
</template>

<style lang="scss">
@import './layout.scss';
</style>
